<div class="linkContainer">
  <p-dialog [(visible)]="tableDataIsLoading" [showHeader]="false" [resizable]="false" [modal]="true"
  [focusOnShow]="false" class="progress-overlay">
    <div style="width: 200px; height: 150; padding-top: 5%" class="text-center">
    <p-progressSpinner [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>
    </div>
  </p-dialog>
  <p-table [value]="records" [lazy]="true" (onLazyLoad)="loadRecordsLazy($event)" [paginator]="true" [rows]=15 [totalRecords]="totalCount">

    <ng-template pTemplate="header" let-columns>
      <tr>
          <th *ngFor="let col of cols" [pSortableColumn]="col.field" class="gradient-dark-yellow">
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'resolution'" class="gradient-dark-yellow" id="headerStyle">              
            Variance Type   
            <p-sortIcon [field]="'resolution'"></p-sortIcon>         
          </th>
          <th class="share-col-header" class="gradient-dark-yellow">
              <strong>Select</strong>
          </th>
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-columns="cols" >
      <tr [class]="getChildRowClass(rowData?.RecordType)">
          <td style="height:50px" *ngFor="let col of cols" [ngSwitch]="col.field">
              <span *ngSwitchCase="'amount'">{{rowData[col.field] | formatQuantity}}</span>
              <span *ngSwitchDefault>{{rowData[col.field]}}</span>
          </td>
          <td  [ngClass]="getResolutionBg(rowData?.resolution)">
            {{rowData?.resolution}}
          </td>
          <td>
              <input class="form-control share-check" (change)="toLink($event, rowData)" type="checkbox" [(ngModel)]="rowData.isSelected" id="flexCheckDefault">
          </td>
      </tr>
    </ng-template>
  </p-table>
</div> 